import { Injectable, EventEmitter } from '@angular/core';
import { ModalPromptComponent } from './modal-prompt.component';
import { MaterializeAction } from 'angular2-materialize';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Rx';

type ActionWhenConfirmed = (data:any) => boolean;

@Injectable()
export class ModalPromptService{
    
    private _prompt: ModalPromptComponent;

    set(prompt: ModalPromptComponent){
        this._prompt = prompt;
    }

    openModal(callback: ActionWhenConfirmed, returnThisDataIfConfirmed: any, options: PromptOptions = {header: 'Please Confirm', body:'Are you sure you want to perform the requested action?'}) : Subject<any>{
        return this._prompt.modalOpen(callback, returnThisDataIfConfirmed, options)
    }
 
}

export class PromptOptions{
    header: string;
    body: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/helper-components/modal-prompt.service.ts